export const addCheckboxesToDomForFacets = () => {
    $(".top-facet[data-fid]").each(function() {
        var $thisFacet = $(this),
            thisFacetID = $thisFacet.data("fid"),
            thisFacetInfo = facetsJSON[thisFacetID];
        if ($thisFacet.find("ul").length == 0) {
            var htmlForInsert = `<div class="facet-wrapper"><div class="facet-scroll"><ul class="facet">`;
            $(thisFacetInfo.values).each(function(index) {
            	if(this.dsp != ''){
	                this.dspPretty = this.dsp.split("#double;").join('&quot;');
	                this.dsp = this.dsp.split("#double;").join('"');
	                var urlFacetValue = this.dsp.trim().split(' ').join('-').split('/').join('-').split('"').join('').split('+').join('').toLowerCase();
	                var urlFacetName = thisFacetInfo.facetTitle.trim().split(' ').join('-').split('/').join('-').split('"').join('').toLowerCase();
	                htmlForInsert += `<li data-twist="${thisFacetInfo.facetTitle}${index}">`;
	                if (thisFacetInfo.facetTitle == 'Color') htmlForInsert += `<span class="GuidedNavColorSwatch ${this.dsp.split('/').join('')}" aria-labelledby="Color Swatch ${this.dsp.split('/').join('')}" role="img"></span>`;
	                htmlForInsert += `<label for="${this.id}"><input data-twist="${thisFacetInfo.facetTitle}" data-facetname="${thisFacetInfo.facetTitle}" type="checkbox" id="${this.id}" value="${this.val}">`;
	                var htmlFrag1 = `<span id="facetLabel_${this.id}" data-twist="${this.dspPretty}"  data-prettyattr="${this.dspPretty}" data-urlFacetValue="${urlFacetValue}"> `,
	                    frag1 = `<a class="facet-href" href="${this.seoURL}">${this.dsp}</a>`,
	                    frag2 = `${this.dsp}`,
	                    htmlFrag2 = (this.seoURL) ? frag1 : frag2;
	                htmlForInsert += `${htmlFrag1}${htmlFrag2}<span class="hideFacetCount" id="facet_count${this.id}">${this.cnt}</span></span></label></li>`;
            	}
            });
            htmlForInsert += `</ul></div><a href="javascript:void(0)" class="btn btn-secondary close-filter" data-close-filter>Done</a></div>`;
            $thisFacet.append(htmlForInsert);
        }
    });
    //Temp fix, we need to remove in managment center
    $('.side-facet .fa-minus').remove();
};
